<mapfre-modal
*ngIf="isNativeApp && isUpdateNeeded"
[modalOptions]="appUpdateModal"
(click)="hideModal()" 
[hideModal]="hideModalOnRoute"
>
<div class="modal-body">
  <hr class="margin-bottom mb24 no-margin-top" />
  <div class="margin-bottom mb24">
    {{
      "APP_UPDATE_AVAILABLE"
        | translate
    }}
  </div>
  <div class="mx-auto text-center">
    <div>
      <mapfre-button
        additionalClasses="basic primary large-btn"
        (click)="hideModal('update')"
      ><a class="no-text-decoration" [href]="appLink">
        {{
          "UPDATE" | translate
        }}
        </a>
      </mapfre-button>
    </div>
    <div class="margin-top mt24">
      <mapfre-button
        additionalClasses="ghost secondary large-btn"
        (click)="hideModal()"
      >
        {{ "CANCEL" | translate }}
      </mapfre-button>
    </div>
  </div>
</div>
</mapfre-modal>

<ng-container *ngIf="isAvailable; else showApp">
  <div>
    <mapfre-header [hideModal]="true"></mapfre-header>
    <div class="center-on-page container-fluid maintenance-sorry-page">
      <div class="head margin-bottom mb24">
        {{ "SYSTEM_DOWN_MAINTENANCE" | translate }}
      </div>

      <div class="inprogress margin-bottom mb24">
        {{ "MAINTENANCE_INPROGRESS" | translate }}
      </div>

      <div class="inprogress margin-bottom mb24">
        <b>{{ "MAINTENANCE_TIME" | translate }}</b>
      </div>

      <ng-container *ngIf="stateCode==='ACMIC'; else maState">
        <div class="margin-bottom mb24 ">
        <div class="assistance acmic margin-top mt16">
          {{ "MAINTENANCE_ASSISTANCE" | translate }}
            {{ " please contact us at" }}
            <a href="tel:18442954500">
              {{ "1-844-295-4500" }}
            </a>
          </div>
          <div class="assistance acmic contact margin-top mt8">
              {{ "CONTACT_CENTER_HOURS_ACMIC" | translate }} {{ "|" }} {{ "CONTACT_CENTER_HOURS_2_ACMIC" | translate }} {{ "|" }} {{ "Claims 24/7" }} 
        </div>
      </div>
      </ng-container>
      <ng-template #maState>
        <div class="assistance margin-bottom mb24">
          {{ "MAINTENANCE_ASSISTANCE" | translate }}
          <div class="display-inline">
            {{ " please" }}
            <a href="https://www.mapfreinsurance.com/contact/">
              {{ "contact us " }}
            </a>
            {{ "or your agent" }}
          </div>
        </div>
      </ng-template>
    

      <mapfre-button
        additionalClasses="link-button small-btn red-link no-margin button-border-red"
        [backIcon]="'assets/img/icons/back-arrow-red.png'"
        [iconClasses]="'align-middle'"
        [showIconsCustom]="true"
        (click)="goBack()"
      >
        {{ "BACK" | translate }}
      </mapfre-button>
    </div>
    <mapfre-footer [hideMe]="true" [state]="stateCode"></mapfre-footer>
  </div>
</ng-container>
<ng-template #showApp>
  <div class="body-height">
      <router-outlet></router-outlet>
  </div>
  <div [class]="checkRoute()" *ngIf="isSSR()">
    <mapfre-footer [hideMe]="true" [state]="stateCode"></mapfre-footer>
  </div>
</ng-template>
<div class="hides">App version: {{ appVersion }}</div>

<div [ngClass]="{'grey-background': !connectivity,'green-background': connectivity}" class="text-center" *ngIf="showConnectivity">
    <span *ngIf="!connectivity; else online">{{ 'No Internet Connection' }}</span>
    <ng-template #online>{{ 'Connected to internet' }}</ng-template>
</div>
